// A format block (Native Web Push, InPage, ...) as a section of the platform card. The card saves every changed
// section with one button, so a block does not save itself; it tells the card what it has:
//   sectionKey  the format, as the card's formats tab names it
//   formState   computed: everything that goes into the block's save request; the block is changed when it differs
//               from the state after the last load or save
//   load()      fetches the saved settings, returns a promise
//   validate()  touches the block's validation, returns whether it may be saved
//   save()      sends the settings, returns a promise of { ok, message }
export default {
  inject: {
    cardSections: { default: null },
  },
  data() {
    return {
      savedState: null,
    };
  },
  computed: {
    sectionDirty() {
      return this.savedState !== null && JSON.stringify(this.formState) !== this.savedState;
    },
  },
  mounted() {
    if (this.cardSections) this.cardSections.register(this);
    Promise.resolve(this.load()).finally(this.markSaved);
  },
  beforeDestroy() {
    if (this.cardSections) this.cardSections.unregister(this);
  },
  methods: {
    // Watchers of the loaded values may still adjust them: take the state once they ran
    markSaved() {
      this.$nextTick(() => {
        this.savedState = JSON.stringify(this.formState);
      });
    },
    async saveSection() {
      const result = await this.save();
      if (result && result.ok) this.markSaved();
      return result;
    },
    async discardSection() {
      this.savedState = null;
      await this.load();
      this.markSaved();
    },
  },
};

// The settings API answers { status, message }: anything but 200 is an error to show.
export function saveResult(res, fallbackMessage) {
  if (res && res.status === 200) return { ok: true };
  return { ok: false, message: (res && res.message) || fallbackMessage };
}
